<template>
  <div>
    <NavBar />
  </div>
  <div>
    <router-view />
  </div>
  <div>
    <FooterPage />
  </div>
  
</template>

<script>
import NavBar from './components/NavBar.vue';
import FooterPage from './components/FooterPage.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    FooterPage
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  padding-top: 100px !important; /* Adjust this value */
}
</style>
